<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button, RadioGroup, Radio } from "view-design";
let customerId = window.localStorage.getItem("customerId");
import config from "../../../config";
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "schedule",
        key: "id",
        url: {
          list: "/admin/system/schedule/list",
          del: "/admin/system/schedule",
        },
        output: false,
      },
      actions: [
        {
          label: "新建流程",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
        },
      ],
      menus: [],
      filters: [],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "流程名称",
          key: "workflowName",
          minWidth: 300,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.workflowName;
            return (
              <span
                style={{ "font-size": "14px", cursor: "pointer", color: "#2d8cf0" }}
                onClick={() => this.toInfo(row.id)}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 110,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.toEdit(row.id)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  编辑
                </Button>
                <Button
                  size="small"
                  onClick={() => this.delItem(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  删除
                </Button>
              </div>
            );
          },
          auth: {
            edit: "/maintainer/maintainer/sysTask/edit",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toInfo(row) {
      $utils.url.push({
        name: "add_Process",
        query: {
          kv: row,
          action: "edit",
        },
      });
    },
    toEdit(row) {
      $utils.url.push({
        name: "add_Process",
        query: {
          kv: row,
          action: "edit",
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/schedule/del/${row.id}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
    toAdd(row) {
      $utils.url.push({
        name: "add_Process",
        query: {
          action: "add",
        },
      });
    },
    async invoicelist(row) {
      $utils.url.push({
        name: "invoice_Info",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>

<style></style>
